export default "﻿<div>\n    <table class=\"w3-table w3-bordered\" data-dojo-attach-point=\"opusAddressList\"> \n    </table>\n</div>"